module.exports = __webpack_public_path__ + "/login_ui/img/bj-8d6fbc8364c041ef944309fe4c0591e9.svg";